import {useEffect, useState} from "react";
import type { ContextProps } from '../../../types';
import {PageTitle} from "../../../Components/Landmarks";
import {packingListApi} from "./packingListApi";
import {packingListModel} from "./packingListFactory";
import {isObjectNullOrEmpty} from "../../../Utilities/Types/objectUtilities";
import {PackingListFooterView} from "../PackingListFooterView";
import {PackingListHeaderView} from "../PackingListHeaderView";
import type {TextbookPackingList} from "../packingList.types";

export const PackingListContainer = ({
                                         handleApiCall,
                                         orderId,
                                         queueItemId,
                                     }: ContextProps) => {
    const [packingList, setPackingList] = useState<TextbookPackingList | null>(null);

    const updatePackingList = (result: Record<string, unknown>) => {
        setPackingList(packingListModel(result));
    }

    const handleGetLoanPackingList = () => {
        handleApiCall(() => packingListApi.getLoanPackingList(queueItemId), updatePackingList);
    }

    const handleGetOrderPackingList = () => {
        handleApiCall(() => packingListApi.getOrderPackingList(orderId), updatePackingList);
    }

    useEffect(() => {
        if (queueItemId)
            handleGetLoanPackingList();
        if (orderId)
            handleGetOrderPackingList();
    }, []);

    if (!packingList) return null;

    return <>
        <PackingListHeaderView shipAddress={packingList.shipAddress}/>

        <div className={`packingList`}>

            <hr/>

            <PageTitle h1={`Packing List`}/>

            <p>Ship Date: {packingList.shipDate}</p>

            <p className={`text-center`}><b>The following item is contained in _______________ packages.</b></p>

            <div>Order Date: {packingList.orderDate}</div>
            <div>For Student: {packingList.studentName}</div>
            <div>District: {packingList.district}</div>
            <div>Description: {packingList.description}</div>
            <div>Access No: {packingList.accessNumber}</div>
            <div>ISBN#: {packingList.isbn}</div>
            <div>Medium: {packingList.medium}</div>
            <div>Volumes: {packingList.volumes}</div>
            <div>Packing Note: {packingList.orderStatus}</div>
        </div>

        <PackingListFooterView/>
    </>;
};

